






























































import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import raidsAPI from "@/api/raids";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import { GetRaidsResponse } from "@/api/raids/get-raids.response";
import { RaidGroupResponse } from "@/api/raids/get-raid-groups.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";
import { Guid } from "@/domain/guid";


/**
 * VueX Modules
 */


interface EditCompositionGroupForm {
	name: string;
	selectedInstance: string | null;
}

/**
 * Edit composition group modal.
 */
@Component({
	components: {DataFetcher}
})
export default class EditCompositionGroupDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterEdit!: (id: Guid) => Promise<void>;

	/// Attributes
	isLoading = false;
	originalCompositionGroup: GetOneCompositionGroupResponse | null = null;
	originalSelectedInstance: string | null = null;
	raids: GetRaidsResponse.Raid[] | null = null;
	raidGroups: RaidGroupResponse[] | null = null;

	get displayedRaids() {
		const items: any[] = [{
			name: this.$t("composition.no_instance"),
			value: null,
			zoneID: null
		}];
		if (this.raidGroups && this.raidGroups.length > 0) {
			for (const rg of this.raidGroups) {
				items.push({
					name: rg.name,
					value: "rg:" + rg.id,
					zoneID: rg.zoneID
				});
			}
		}
		if (this.raids) {
			for (const r of this.raids) {
				items.push({
					name: r.name,
					value: r.id,
					zoneID: r.zoneID
				});
			}
		}
		return items;
	}

	get hasInstanceChanged() {
		return this.editCompositionGroupForm != null && this.originalSelectedInstance !== this.editCompositionGroupForm.selectedInstance;
	}


	// Form
	editCompositionGroupForm: EditCompositionGroupForm | null = null;

	/// VueX Modules


	get canSubmit() {
		return this.editCompositionGroupForm && this.editCompositionGroupForm.name;
	}

	/// Methods
	async open(compositionGroup: GetOneCompositionGroupResponse) {
		this.$refs.modal.open();

		this.originalCompositionGroup = compositionGroup;

		const selectedInstance = compositionGroup.raidGroupID
			? "rg:" + compositionGroup.raidGroupID
			: compositionGroup.raidID;

		this.originalSelectedInstance = selectedInstance;

		this.editCompositionGroupForm = {
			name: compositionGroup.name,
			selectedInstance: selectedInstance
		};
	}

	async fetch() {
		await this.refreshRaids();
	}

	close() {
		this.$refs.modal.close();
	}

	async refreshRaids() {
		const [raids, raidGroups] = await Promise.all([
			raidsAPI.fetchRaids(),
			raidsAPI.fetchRaidGroups()
		]);
		this.raids = raids;
		this.raidGroups = raidGroups;
	}

	async handleSubmit() {
		if (!this.canSubmit || !this.originalCompositionGroup || !this.editCompositionGroupForm) {
			return;
		}

		let raidID: Guid | null = null;
		let raidGroupID: Guid | null = null;
		const sel = this.editCompositionGroupForm.selectedInstance;

		if (sel != null) {
			if (typeof sel === "string" && sel.startsWith("rg:")) {
				raidGroupID = sel.substring(3);
			} else {
				raidID = sel;
			}
		}

		this.isLoading = true;
		try {
			const id = await compositionsAPI.editComposition(this.originalCompositionGroup.id, {
				name: this.editCompositionGroupForm.name,
				raidID: raidID,
				raidGroupID: raidGroupID
			});
			if (this.onAfterEdit) {
				await this.onAfterEdit(id);
			}
			this.close();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
